/**
 * Shared rich-text sanitizer for admin-authored HTML content
 * (Fundraising Academy articles and Platform News updates).
 *
 * Extracted from ArticleDetail.tsx so both content types use one
 * identical DOMPurify configuration and it cannot drift.
 */

import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p", "br", "strong", "em", "u",
  "h1", "h2", "h3", "h4", "h5", "h6",
  "ul", "ol", "li", "a", "img", "blockquote", "code", "pre",
  "div", "span", "table", "thead", "tbody", "tr", "th", "td",
];

const ALLOWED_ATTR = ["href", "src", "alt", "title", "class", "id", "target", "rel"];

// The `\-` in the second class is deliberate and must stay escaped: there
// `-` sits between `.` and `:`, so unescaping it would form the range
// .-: (0x2E-0x3A) and silently start allowing `/` and digits. Only the
// first class, where `-` is already last and the escape is inert, is
// unescaped here.
const ALLOWED_URI_REGEXP =
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i;

/** Sanitize admin-authored HTML for rendering via dangerouslySetInnerHTML. */
export function sanitizeRichText(html: string | null | undefined): string {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
  });
}
